export default "__VITE_ASSET__CgZm24mQ__"